import { animations } from "@/assets/animations";
import Lottie from "react-lottie";
import { Button } from "../ui/button/button";
import { ButtonSize } from "../ui/button/button.type";
import classNames from "classnames";
import { FC } from "react";
import { useSmartWallet } from "@/contexts";

type ConnectWalletCtaType = {
  size?: ButtonSize;
};

const lottieStyle = {
  marginTop: {
    sm: "8px",
    md: "10px",
    lg: "8px",
  },
};
export const ConnectWalletCta: FC<ConnectWalletCtaType> = ({
  size = ButtonSize.medium,
}) => {
  const { login, isConnecting } = useSmartWallet();

  const loader = () => (
    <Lottie
      style={{
        height: "24px",
        width: "24px",
        margin: "0px",
        marginTop: lottieStyle.marginTop[size],
        marginLeft: "4px",
      }}
      options={{
        loop: true,
        autoplay: true,
        animationData: animations.LOADER_GREEN,
      }}
      speed={1.2}
    />
  );

  return (
    <div className="w-full">
      {isConnecting ? (
        <div
          className={classNames({
            "border-1 row flex h-10 h-[32px] justify-center rounded-md border border-primary bg-new-orders-button-gradient px-4 text-sm text-text-primary":
              true,
            "h-[32px] text-sm": size == ButtonSize.small,
            "text-md h-[44px]": size == ButtonSize.medium,
            "h-[52px] text-sm": size == ButtonSize.large,
          })}>
          <div className="row flex items-center justify-start">
            <p className="font-satoshiBold">Connecting</p>
            {loader()}
          </div>
        </div>
      ) : (
        <Button label="Get Started" onClick={login} widthFull size={size} />
      )}
    </div>
  );
};
